'use strict';

var React = require('react');
var AddButton = require('@swiggy-private/dls-web-core/dist/components/AddButton');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var ItemInfo = require('../../ItemInfo-BZWKuv-x.js');
var ItemPrice = require('../../ItemPrice-BSDHM3Zk.js');
var GenericIconWeb = require('@swiggy-private/dls-web-icons/dist/GenericIconWeb');
var styled = require('styled-components');
var components_ItemListWidget_types = require('./types.js');
var _delete = require('@swiggy-private/dls-web-icons/dist/web/generic/delete');
var helpers = require('../../helpers-BjcsXRdQ.js');
require('@swiggy-private/dls-web-food-icons/dist/web/nonveg');
require('@swiggy-private/dls-web-food-icons/dist/web/veg');
require('@swiggy-private/dls-web-icons/dist/web/generic/chevronDown');
require('../../_tslib-D25eJ2i9.js');
require('@swiggy-private/js-utils');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const ListWrapper = styled__default.default("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing.small,
}));
const ItemInfoWrapper = styled__default.default.div `
    flex: 1;
    overflow: hidden;
    margin: auto 0;
`;
const AddButtonContainer = styled__default.default("div")(({ theme }) => ({
    marginLeft: theme.spacing.large,
}));
const UnavailableButton = styled__default.default("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "76px",
    height: "30px",
    contain: "content",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    border: `1px solid ${theme.colors[theme.colorMode].background_Button_Disabled}`,
    borderRadius: theme.spacing.xSmall,
}));
const DeleteIconContainer = styled__default.default("div")(({}) => ({
    minWidth: "45px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
}));
const DeleteIconStyled = styled__default.default(GenericIconWeb.GenericIcon)(({}) => ({
    display: "inline-block",
    width: "fit-content",
    height: "fit-content",
    verticalAlign: "middle",
}));

const ItemListWidget = ({ dishInfo, onItemAction, isUpdating, setUpdatingItemId, }) => {
    const { info, selectedInfo, unId } = dishInfo;
    const { inStock, name, isVeg, addons: itemAddons, variantsV2: itemVariants } = info;
    const { priceInfo, addons, quantity, variantsV2 } = selectedInfo;
    const { basePrice, finalPrice } = priceInfo;
    const isInStock = React.useMemo(() => inStock === 1, [inStock]);
    const isCustomisable = React.useMemo(() => helpers.isItemCustomisable(itemAddons, itemVariants === null || itemVariants === void 0 ? void 0 : itemVariants.variantGroups), [itemAddons, itemVariants === null || itemVariants === void 0 ? void 0 : itemVariants.variantGroups]);
    const onIncrement = React.useCallback((event) => {
        event.stopPropagation();
        setUpdatingItemId(unId);
        onItemAction(components_ItemListWidget_types.ItemActionType.INCREMENT_ITEM, dishInfo);
    }, [dishInfo, unId, onItemAction, setUpdatingItemId]);
    const onDecrement = React.useCallback((event) => {
        event.stopPropagation();
        setUpdatingItemId(unId);
        onItemAction(components_ItemListWidget_types.ItemActionType.DECREMENT_ITEM, dishInfo);
    }, [dishInfo, unId, onItemAction, setUpdatingItemId]);
    const onClickDelete = React.useCallback(() => {
        setUpdatingItemId(unId);
        onItemAction(components_ItemListWidget_types.ItemActionType.REMOVE_ITEM, dishInfo);
    }, [dishInfo, unId, onItemAction, setUpdatingItemId]);
    return (React__default.default.createElement(ListWrapper, null,
        React__default.default.createElement(ItemInfoWrapper, null,
            React__default.default.createElement(ItemInfo.ItemInfo, { name: name, isCustomisable: isCustomisable, addons: addons || [], variants: variantsV2 || { variantGroups: [] }, vegType: isVeg })),
        React__default.default.createElement(AddButtonContainer, null, isInStock ? (React__default.default.createElement(AddButton.AddButton, { value: quantity.value, onClickIncrement: onIncrement, onClickDecrement: onDecrement, size: "small", updating: isUpdating, disableBoxShadow: true, customQtyColor: "text_High_Emphasis" })) : (React__default.default.createElement(UnavailableButton, null,
            React__default.default.createElement(Text.Text, { variant: "V2.caption.neutral.medium", color: "text_Med_Emphasis" }, ItemInfo.UNAVAILABLE)))),
        isInStock ? (React__default.default.createElement(ItemPrice.ItemPrice, { price: basePrice, finalPrice: finalPrice })) : (React__default.default.createElement(DeleteIconContainer, { onClick: onClickDelete },
            React__default.default.createElement(DeleteIconStyled, { Icon: _delete.Svg20, strokeColor: "text_Med_Emphasis", fillColor: "text_Med_Emphasis" })))));
};
var ItemListWidget$1 = React.memo(ItemListWidget);

Object.defineProperty(exports, "ItemActionType", {
    enumerable: true,
    get: function () { return components_ItemListWidget_types.ItemActionType; }
});
exports.ItemListWidget = ItemListWidget$1;
//# sourceMappingURL=index.js.map
